import { DataGrid, Grid, Paper } from "@pankod/refine-mui";
import React, { useState } from "react";
import HeaderStatistiche from "./HeaderStatistiche";

function StatisticheSistemazioni() {
  const [data, setData] = useState(undefined);
  const [loading, setLoading] = useState(false);

  const columnsSistemazioni = [
    {
      field: "accommodationName",
      headerName: "Sistemazioni",
      minWidth: 180,
      flex: 1,
    },
    {
      field: "totalBookings",
      headerName: "NumeroPrenotazioni",
      minWidth: 80,
      flex: 1,
    },
    {
      field: "totalNights",
      headerName: "Numero notti",
      minWidth: 80,
      flex: 1,
    },
    {
      field: "totalRevenuePerNight",
      headerName: "Fatturato a notte",
      minWidth: 80,
      flex: 1,
      valueGetter: ({ row }) => {
        return row.totalRevenuePerNight?.toFixed(2) + " €";
      },
    },
    {
      field: "totalCancellationsAmount",
      headerName: "Cancellazioni",
      minWidth: 80,
      flex: 1,
      valueGetter: ({ row }) => {
        return row.totalCancellationsAmount?.toFixed(2) + " €";
      },
    },
    {
      field: "totalRevenue",
      headerName: "Fatturato totale",
      minWidth: 80,
      flex: 1,
      valueGetter: ({ row }) => {
        return row.totalRevenue?.toFixed(2) + " €";
      },
    },
  ];

  return (
    <Paper sx={{ p: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <HeaderStatistiche setData={setData} setLoading={setLoading} />
        </Grid>
        <Grid item xs={12}>
          {data?.accommodations && (
            <DataGrid
              rows={data?.accommodations}
              getRowId={(row) => row.accommodation}
              columns={columnsSistemazioni}
              pageSize={data?.accommodations?.length}
              pagination
              components={{
                Pagination: () => {
                  return null;
                },
              }}
              autoHeight
              sx={{
                border: "none",
                "& .MuiDataGrid-columnHeaders": {
                  background: "rgb(242, 242, 242)",
                  borderBottom: "1px solid rgb(229, 229, 229)",
                },
                "& .MuiDataGrid-cell": {
                  borderBottom: "1px solid rgb(242, 242, 242)",
                },
              }}
              disableSelectionOnClick={true}
            />
          )}
        </Grid>
      </Grid>
    </Paper>
  );
}

export default StatisticheSistemazioni;
